import React from 'react';
import PropTypes from 'prop-types';

import Button from '../button';
import Modal from '../modal';

const PaymentMethodModal = ({ openAddCardModal, isLoading, onClose, isCreditCardsDisabled, ...props }) => {

  return (
    <Modal {...props} onClose={onClose} className="payment-method-modal" isHalfling>
      <div className="modal_header">
        <h4 className="js-modal-title">Add new payment method</h4>
      </div>
      <div className="modal_body payment-method-modal__body">
        {!isCreditCardsDisabled && (
          <Button
            xSize="full"
            color="blue"
            disabled={props.isLoading}
            onClick={() => {
              openAddCardModal();
              onClose();
            }}
          >
          Add credit card
          </Button>
        )}
        <Button
          xSize="full"
          color="blue"
          disabled={props.isLoading}
          target="_blank"
          href="/bank-accounts/instant"
        >
          Add Bank Account
        </Button>
        <p>
          Add and verify Bank account instantly in your Wallet.<br />Opens in a new tab
        </p>
      </div>
      <div className="modal_footer">
        <div className="modal_footer-controls">
          <Button
            xSize="full"
            transparency="full"
            className="js-cancel-button modal_footer-control -cancel"
            disabled={props.isLoading}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PaymentMethodModal.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  openAddCardModal: PropTypes.func,
  isCreditCardsDisabled: PropTypes.bool,
};

PaymentMethodModal.defaultProps = {
  isLoading: false,
  openAddCardModal: () => {},
};

export default PaymentMethodModal;
